(() => {
  const selector = '[data-nfg-cart-progress]';

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return currency + ' ' + (cents / 100).toFixed(2);
    }
  }

  function updateMeter(meter) {
    const baseThreshold = Number(meter.dataset.baseThreshold);
    const cartTotal = Number(meter.dataset.cartTotal);
    const currency = window.Shopify?.currency?.active || meter.dataset.currency || 'AUD';
    const rate = Number(window.Shopify?.currency?.rate);

    if (!Number.isFinite(baseThreshold) || !Number.isFinite(cartTotal)) return;
    if (currency !== 'AUD' && (!Number.isFinite(rate) || rate <= 0)) return;

    const threshold = currency === 'AUD'
      ? baseThreshold
      : Math.round(baseThreshold * rate);
    const remaining = Math.max(0, threshold - cartTotal);
    const progress = threshold > 0
      ? Math.min(100, Math.max(0, (cartTotal / threshold) * 100))
      : 100;

    const message = meter.querySelector('[data-nfg-cart-progress-message]');
    const track = meter.querySelector('[data-nfg-cart-progress-track]');
    const bar = meter.querySelector('[data-nfg-cart-progress-bar]');

    if (!message || !track || !bar) return;

    message.textContent = remaining > 0
      ? `Add ${formatMoney(remaining, currency)} for free international shipping.`
      : 'Free international shipping unlocked.';

    track.hidden = false;
    track.setAttribute('aria-valuenow', String(Math.round(progress)));
    track.setAttribute(
      'aria-label',
      remaining > 0
        ? 'Progress toward free international shipping'
        : 'Free international shipping unlocked'
    );
    bar.style.width = `${progress}%`;
  }

  function updateAllMeters() {
    document.querySelectorAll(selector).forEach(updateMeter);
  }

  const observedRegions = new WeakSet();

  function observeCartRegions() {
    ['CartDrawer', 'main-cart-footer'].forEach((id) => {
      const region = document.getElementById(id);
      if (!region || observedRegions.has(region)) return;

      observedRegions.add(region);
      new MutationObserver((mutations) => {
        const hasNewMeter = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some((node) =>
            node.nodeType === 1 &&
            (node.matches?.(selector) || node.querySelector?.(selector))
          )
        );

        if (hasNewMeter) updateAllMeters();
      }).observe(region, { childList: true, subtree: true });
    });
  }

  function initialiseMeters() {
    updateAllMeters();
    observeCartRegions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseMeters, { once: true });
  } else {
    initialiseMeters();
  }

  document.addEventListener('shopify:section:load', initialiseMeters);
  document.addEventListener('cart:updated', updateAllMeters);
  document.addEventListener('cartUpdate', updateAllMeters);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateAllMeters);
  }
})();